import snakeCase from 'lodash/snakeCase';

export default function getNewsboard(prefix) {
  if (/^localhost$|^[^.]*dashboard\./.test(prefix)) {
    return 'FASHIONUNITED_IE';
  }

  return snakeCase(
    prefix
      .replace(/^(ru|cn)\.fashionunited\.com$/, 'fashionunited.$1'),
  ).toUpperCase();
}
